export default "__VITE_ASSET__BZ0DtL2K__ 720w";